(() => {
  if (window.__motTierInit) return;
  window.__motTierInit = 1;

  const esc = (window.CSS && CSS.escape) ? CSS.escape : (s => String(s).replace(/["\\]/g, "\\$&"));

  const init = (form) => {
    if (!form || form.__motTier) return;

    const root = form.querySelector('#mot-customizer');
    if (!root) return;

    let maxList = (root.dataset.tierMax || "2,4,7,10")
      .split(",").map(n => parseInt(n, 10)).filter(Number.isFinite);
    if (!maxList.length) maxList = [10];

    const tierValues = (root.dataset.tierValues || "0-2|3-4|5-7|8-10")
      .split("|").map(s => s.trim()).filter(Boolean);

    const maxAllowed = Math.max(...maxList);

    const spans = {};
    form.querySelectorAll('.tpo_selected_values_span[data-mot-selected-group]')
      .forEach(s => spans[s.dataset.motSelectedGroup] = s);

    const prop = (id) => form.querySelector('#' + id);
    const propF  = prop('mot-prop-fleurs');
    const propP  = prop('mot-prop-plantes');
    const propFr = prop('mot-prop-fruits');
    const propA  = prop('mot-prop-aromes');
    const propC  = prop('mot-prop-count');
    const propT  = prop('mot-prop-tier');

    const errorBox = form.querySelector('#ingredient_limit_error_message');
    const errorClose = errorBox && errorBox.querySelector('.close');
    let timer = 0;

    const pickTier = (c) =>
      tierValues[maxList.findIndex(m => c <= m)] || tierValues[tierValues.length - 1] || "";

    const setTierOption = (v) => {
      const sel = form.querySelector('select[name="options[Palier]"],select[name="options[1]"]');
      if (sel) {
        if (sel.value !== v) {
          sel.value = v;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          sel.dispatchEvent(new Event('input', { bubbles: true }));
        }
        return;
      }
      const r = form.querySelector(
        `input[name="options[Palier]"][value="${esc(v)}"],input[name="options[1]"][value="${esc(v)}"]`
      );
      if (r && !r.checked) {
        r.checked = true;
        r.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };

    const read = () => {
      const groups = { "Fleur": [], "Plante - Feuille - Herbe - Graine": [], "Fruit": [], "Arome": [] };
      const checked = [...form.querySelectorAll('input.mot-ing[data-mot-group]:checked')];
      checked.forEach(i => groups[i.dataset.motGroup] && groups[i.dataset.motGroup].push(i.value));
      return { count: checked.length, groups };
    };

    const setErr = (show) => errorBox && errorBox.classList.toggle('hidden', !show);

    const sync = () => {
      const { count, groups } = read();

      const vF  = groups["Fleur"].join(", ");
      const vP  = groups["Plante - Feuille - Herbe - Graine"].join(", ");
      const vFr = groups["Fruit"].join(", ");
      const vA  = groups["Arome"].join(", ");

      propF  && (propF.value  = vF);
      propP  && (propP.value  = vP);
      propFr && (propFr.value = vFr);
      propA  && (propA.value  = vA);
      propC  && (propC.value  = "" + count);

      spans["Fleur"] && (spans["Fleur"].textContent = vF);
      spans["Plante - Feuille - Herbe - Graine"] && (spans["Plante - Feuille - Herbe - Graine"].textContent = vP);
      spans["Fruit"] && (spans["Fruit"].textContent = vFr);
      spans["Arome"] && (spans["Arome"].textContent = vA);

      const tier = pickTier(count);
      propT && (propT.value = tier);
      tier && setTierOption(tier);

      if (count <= maxAllowed) {
        setErr(false);
        timer && clearTimeout(timer);
        timer = 0;
      }
    };

    errorClose && errorClose.addEventListener('click', (e) => {
      e.preventDefault();
      setErr(false);
      timer && clearTimeout(timer);
      timer = 0;
    });

    form.addEventListener('change', (e) => {
      const t = e.target;
      if (!t || !t.matches || !t.matches('input.mot-ing[data-mot-group]')) return;

      const c = form.querySelectorAll('input.mot-ing[data-mot-group]:checked').length;
      if (c > maxAllowed) {
        t.checked = false;
        sync();                // resync d'abord (ça remet prix/palier/count)
        setErr(true);          // puis on affiche l'erreur (sinon sync la masque)
        timer && clearTimeout(timer);
        timer = setTimeout(() => setErr(false), 10000);
        return;
      }
      sync();
    }, true);

    form.__motTier = 1;
    sync();
  };

  const scan = (node) => {
    if (!node || node.nodeType !== 1) return;

    if (node.matches && node.matches('#mot-customizer')) {
      init(node.closest('form'));
      return;
    }
    node.querySelectorAll && node.querySelectorAll('#mot-customizer').forEach(r => init(r.closest('form')));
  };

  scan(document.documentElement);

  new MutationObserver((ms) => {
    ms.forEach(m => m.addedNodes && m.addedNodes.forEach(scan));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();



(()=>{const N=8,D=180,SEL=".mot-aromas",W=".tpo_image-swatches-wrapper",I="input.tpo_color-swatches-input";
const T=new WeakMap(),q=(r,s)=>[...r.querySelectorAll(s)],clr=c=>{(T.get(c)||[]).forEach(clearTimeout);T.set(c,[])},
tog=c=>c.querySelector(W+".mot-toggle"),extra=c=>q(c,W+":not(.mot-toggle)").slice(N),
icon=(c,o)=>{const t=tog(c);if(t){t.dataset.open=o?1:0;t.querySelector(".mot-toggle-icon").textContent=o?"-":"+"}},
mk=()=>{const d=document.createElement("div");d.className="tpo_image-swatches-wrapper mot-toggle";
d.innerHTML='<div class="tpo_shape_circle"><div><span class="mot-toggle-icon">+</span></div></div>';return d},
show=(c,els)=>{clr(c);let ts=[];els.forEach((e,i)=>{e.style.transitionDelay=i*40+"ms";e.classList.add("mot-anim-out");
e.classList.remove("hidden");requestAnimationFrame(()=>e.classList.remove("mot-anim-out"))});
ts.push(setTimeout(()=>els.forEach(e=>e.style.transitionDelay=""),D+els.length*40+30));T.set(c,ts);icon(c,1)},
hide=(c,els)=>{
  clr(c); icon(c,0);
  const L=els.length; let ts=[];
  els.forEach((e,i)=>{
    const d=(L-1-i)*40;
    e.style.transitionDelay=d+"ms";
    e.classList.add("mot-anim-out");
    ts.push(setTimeout(()=>{
      e.classList.add("hidden");
      e.classList.remove("mot-anim-out");
      e.style.transitionDelay="";
    },D+d));
  });
  ts.push(setTimeout(()=>els.forEach(e=>e.style.transitionDelay=""),D+(L-1)*40+30));
  T.set(c,ts);
},
init=c=>{if(c.dataset.motInit) return; c.dataset.motInit=1;
const all=q(c,W+":not(.mot-toggle)"); if(all.length<=N) return;
let t=tog(c); if(!t){t=mk();c.appendChild(t)} else c.appendChild(t);
extra(c).forEach(e=>{e.classList.add("hidden");e.classList.remove("mot-anim-out");e.style.transitionDelay=""}); icon(c,0);
t.addEventListener("click",e=>{e.preventDefault();(t.dataset.open=="1"?hide:show)(c,extra(c))});
c.addEventListener("change",e=>{const x=e.target;if(!x.matches(I)||!x.checked) return;
q(c,I+":checked").forEach(i=>{if(i!==x){i.checked=false;i.dispatchEvent(new Event("change",{bubbles:true}))}})});
},
scan=r=>q(r,SEL).forEach(init);

scan(document);
document.addEventListener("DOMContentLoaded",()=>scan(document));

let raf=0;
new MutationObserver(m=>{if(raf) return; raf=requestAnimationFrame(()=>{raf=0;
m.forEach(x=>x.addedNodes&&x.addedNodes.forEach(n=>n.nodeType===1&&scan(n)));
})}).observe(document.documentElement,{childList:true,subtree:true});
})();
